import React, { PropsWithChildren, useEffect, useState } from 'react';
import { TbMoodConfuzed } from 'react-icons/tb';
import Drawer from './Drawer';
import CustomerService from '../../Services/CustomerService';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { ImSpinner8 } from 'react-icons/im';
import Scrollbars from 'react-custom-scrollbars-2';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import BoxContentEndScrollbars from './BoxContentEndScrollbars';
import { useCartContext } from '../../Contexts/CartContext';
import { useTranslation } from 'react-i18next';
import { useLoginContext } from '../../Contexts/LoginContext';
import CardOrder from './Profile/CardOrder';
import { useOrderHook } from '../../Hooks/OrderHook';

interface ButtonCustomerOrdersProps {
    className?: string;
}

const ButtonCustomerOrders = ({className, children}: PropsWithChildren<ButtonCustomerOrdersProps>) => {

    const { t } = useTranslation();
    const [showOrders, setShowOrders] = useState(false);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [ordersList, setOrdersList] = useState([]);
    const { orderType } = useOrderTypeContext();
    const { setCurrentOrder, showOrderDetail, setCurrentOrderId } = useCartContext();
    const { user } = useLoginContext();
    const { handleGetDetail } = useOrderHook();    
    const { isMobile } = useLayoutContext();

    const getOrdersList = async () => {
        if (!user?.id) return;
        setShowOrders(true);
        setLoadingOrders(true);
        try {
            const customerService = new CustomerService(orderType);
            const getList = await customerService.getCustomerOrders({user_id: user?.id});
            if (getList.data) {
                setOrdersList(getList.data);
            }
        } catch (error) {
            console.error('Error getOrdersList:', error);
        } finally {
            setLoadingOrders(false);
        }
    }

    useEffect(() => {
        if (!showOrderDetail) {
            setTimeout(() => {//* setTimeout apenas layout
                setCurrentOrder(null);
                setCurrentOrderId(null);
            }, 250);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOrderDetail])

    return (
        <>
            <div onClick={() => getOrdersList()} className={className}>
                {children}
            </div>

            <Drawer open={showOrders}
                title={t('profile.orders.button_customer_orders_label')}
                subtitle={''}
                className={isMobile ? 'ml-2' : ''}
                onClose={() => setShowOrders(false)}
                >
                <section className='p-4 pt-3 flex flex-col h-full gap-4 justify-between'>
                    <div className="h-full">
                        {loadingOrders 
                            ? <div className="flex items-center justify-center gap-1 h-full text-gray-500"><ImSpinner8 className="animate-spin" /> <span>{t('layout.loading')}</span></div>
                            :
                                ordersList.length === 0
                                    ?   <div className="flex items-center justify-center gap-1 h-full text-gray-500"><TbMoodConfuzed /> <span>{t('profile.orders.no_orders_found')}</span></div>
                                    :
                                        <div className='relative flex flex-col gap-3 w-full h-full md:overflow-y-auto'>
                                            <Scrollbars autoHide={true} className='min-h-full'>
                                                <div className='flex flex-col divide-y divide-gray-100 pr-0.5'>
                                                    {ordersList.map((order: any, index: number) => 
                                                        <CardOrder order={order} onClick={() => handleGetDetail(order)} key={order.id ?? index} />
                                                    )}
                                                </div>
                                                <BoxContentEndScrollbars message={t('profile.orders.end_of_list')} />
                                            </Scrollbars>
                                        </div>

                        }
                    </div>
                </section>
            </Drawer>
        </>
    );
};

export default ButtonCustomerOrders;
